import { Mapper } from "../../../../base/utils/mapper";
import { ProcedureMedicationResponseModel } from "../../../../domain/models/consult/procedure-medication-response.model";
import { ProcedureMedicationResponseEntity } from "../entities/procedure-medication-response.entity";

export class ProcedureMedicationImplementationRepositoryMapper extends Mapper<ProcedureMedicationResponseEntity, ProcedureMedicationResponseModel> {
    mapFrom(param: ProcedureMedicationResponseEntity): ProcedureMedicationResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ProcedureMedicationResponseModel): ProcedureMedicationResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}